interface BrevoIdentifyPayload {
  identifiers: {
    email_id: string;
  };
  attributes?: Record<string, string | number | boolean>;
}

type BrevoCommand =
  | ["init", { client_key: string }]
  | ["identify", BrevoIdentifyPayload]
  | ((brevo: BrevoSDK) => void);

interface BrevoSDK {
  push: (command: BrevoCommand) => void;
  identify: (payload: BrevoIdentifyPayload) => void;
}

declare global {
  interface Window {
    Brevo?: BrevoSDK | BrevoCommand[];
  }
}

function isBrowser(): boolean {
  return typeof window !== "undefined";
}

/**
 * Identify the current visitor in Brevo by email (required for visitor tracking).
 * Queues the call until the Brevo SDK is ready.
 */
export function identifyBrevoUser(
  email: string | undefined | null,
  attributes?: Record<string, string | number | boolean>,
): void {
  if (!isBrowser() || !email) return;

  const payload: BrevoIdentifyPayload = {
    identifiers: { email_id: email },
    ...(attributes ? { attributes } : {}),
  };

  window.Brevo = window.Brevo || [];
  window.Brevo.push(["identify", payload]);
}
